import {
  Backdrop,
  Grid,
  Paper,
  Box, 
  Typography,
  Tab,
  Tabs,
  Modal, TextField,
  Button, 
  FormControl, InputLabel,Select,
  MenuItem,IconButton,
  Divider, CircularProgress, Checkbox, FormControlLabel, Card, 
  Dialog, DialogActions, DialogContent, DialogTitle
} from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import RoomServiceIcon from "@mui/icons-material/RoomService";
import DefaultContainer from "../components/DefaultContainer";
import { connect } from "react-redux";
import DefaultHeader from "../components/DefaultHeader";
import Toast from "../components/Snackbar";
import ls from "local-storage";
import Warning from "../components/Warning";
import SkeletonOrder from "../components/SkeletonOrder";
import dayjs from "dayjs";
import { getAreas, getTableGroups, getByTableGroupID, createAndPay,createReservation, getAreaImages } from "../services/Reservation";
import MoneyFormat from "../components/MoneyFormat";
import { getPartnerPolicies } from "../services/Partners";
import customParseFormat from "dayjs/plugin/customParseFormat";
const ReservationScreen = ({ props, cartData, userDetail }) => {
  const navigate = useNavigate();
  const [categoryIndex, setCategoryIndex] = useState(0);
  const [partnerDetails, setPartnerDetails] = useState([]);
  const [menus, setMenus] = useState([]);
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [status, setStatus] = useState(0);
  const [width, setWindowWidth] = useState(0);
  const [height, setWindowHeight] = useState(0);
  const [isOpeningHour, setIsOpeningHour] = useState(false);
  const [msgToast, setMsgToast] = useState("");
  const [loading, setLoading] = useState(false);
  const hours = new Date().getHours();
  const minutes = new Date().getMinutes();
  const seconds = new Date().getSeconds();
  const [selectedTab, setSelectedTab] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [reservationModal, setReservationModal] = useState(false);
  const [selectedTime, setSelectedTime] = useState(null);
  const [selectedTable, setSelectedTable] = useState(null);
  const [selectedTableGroup, setSelectedTableGroup] = useState(null);
  const [areas, setAreas] = useState([])
  const [tableGroups, setTableGroups] = useState([])
  const [tableListByGroupID, setTableListByGroupID] = useState([])
  const [customerName, setCustomerName] = useState(ls.get('redux_localstorage_simple').userData[0]? ls.get('redux_localstorage_simple').userData[0].name:"")
  const [customerPhone, setCustomerPhone] = useState(ls.get('redux_localstorage_simple').userData[0]? ls.get('redux_localstorage_simple').userData[0].phone:"")
  const [customerEmail, setCustomerEmail] = useState(ls.get('redux_localstorage_simple').userData[0]? ls.get('redux_localstorage_simple').userData[0].email:"")
  const [description, setDescription] = useState("");
  const [isLoadingReservasi , setIsLoadingReservasi] = useState(false)
  const [partnerPolicies, setPartnerPolicies] = useState([])
  const [isValid, setIsValid] = useState(false)
  const [areaImage, setAreaImage] = useState([])
  const [adult, setAdult] = useState(2)
  const [child, setChild] = useState(0)
  const [maxPerson, setMaxPerson] = useState([])
  const [error, setError] = useState(false);
  const bookingfee_customer_reservation = ls.get('sfPartner').bookingfee_customer_reservation;
  const [isDialogOpen, setIsDialogOpen] = useState(false)
 // Collect all images (first one is partnerDetails.img_map, others are from areaImage)
  const images = [
  {id:0, image:partnerDetails?.img_map} || {id:0, image:""},
  ...(areaImage || [])
];

const settings = {
  dots: true,          // Show navigation dots
  infinite: true,      // Enable infinite looping
  speed: 500,         // Transition animation speed
  slidesToShow: 1,     // Show one image at a time
  slidesToScroll: 1,   // Scroll one image at a time
  arrows: true,        // Show navigation arrows
  adaptiveHeight: true, // Adjust height dynamically
  autoplay: true,      // Enable auto slide
  autoplaySpeed: 3000, // Change slide every 2 seconds (2000ms)
};


  dayjs.extend(customParseFormat)

  const jam_buka = ls.get("sfPartner").jam_buka;
  const jam_tutup = ls.get("sfPartner").jam_tutup;

  // Function to generate dynamic time slots
  const generateTimeSlots = () => {
    const tomorrow = dayjs().add(1, "day").startOf("day"); // Get tomorrow's date at 00:00
    let startHour = tomorrow.hour(jam_buka.split(":")[0]).minute(jam_buka.split(":")[1]); // Set opening time
    const endHour = tomorrow.hour(jam_tutup.split(":")[0]).minute(jam_tutup.split(":")[1]).subtract(2,"hours"); // Set closing time
  
    // Generate time slots from tomorrow's opening time
    const slots = [];
    let currentTime = startHour;
    while (currentTime.isBefore(endHour)) {
      slots.push(currentTime.format("HH:mm"));
      currentTime = currentTime.add(30, "minute");
    }
  
    return slots;
  };
  
  
    const minDate = dayjs().add(1, "day"); // Start from tomorrow
    const maxDate = dayjs().add(ls.get("sfPartner")?.max_days_reservation || 7, "day"); // Limit to max_days_reservation
  
    const handleDateChange = (e) => {
      const selectedDate = dayjs(e.target.value, "YYYY-MM-DD");
      const formattedDate = selectedDate.format("DD-MM-YYYY");
  
      if (selectedDate.isBefore(minDate) || selectedDate.isAfter(maxDate)) {
        setError(true);
      } else {
        setError(false);
      }
  
      setCustomDate(formattedDate);
    };
  
 const setPersonsArray = () =>{
    let x = ls.get('sfPartner').max_people_reservation;
    let arr = [];
    for (let i = 0; i <= x; i++) {
      arr.push(i)
    }
    return arr;
  }

  // Generate time slots dynamically
  const [timeSlots, setTimeSlots] = useState(generateTimeSlots());

  useEffect(() => {
    setTimeSlots(generateTimeSlots());
    setMaxPerson(setPersonsArray())
  }, []); // Runs only once on component mount
  
  const getTableGroupList = async () => {
    const response = await getTableGroups(ls.get("sfPartner").id, customDate);
    const tableGroups = response.tableGroups
    return tableGroups; // ✅ Return hasilnya
};

  const getAreasData = async () => {
    const response = await getAreas(ls.get("sfPartner").id,(customDate+ " " + selectedTime + ":00"));
    const groupedAreas = response.areas
    return groupedAreas; // ✅ Return hasilnya
  }

  const getAreaImageF = async (id) => {
    const response = await getAreaImages(id);
    const areaImages = response.images
    return areaImages;
  }

  const getTableByGroupIDList = async (tableGroups) => {
    let tablelist = []
    for (let i = 0; i < tableGroups.length; i++) {
      const id_group = (tableGroups[i]).id;
      const response = await getByTableGroupID(ls.get("sfPartner").id, (customDate+ " " + selectedTime + ":00"), id_group);
      tablelist.push(response.areas)
    }
    let tablelistCombine = [];
    for (let i = 0; i < tablelist.length; i++) {
      tablelistCombine.push(tablelist[i])
      
    }   
    tablelist.push(tablelistCombine)
    return tablelist
  }

    const getPartnerPoliciesF = async (id) => {
      const response  = await getPartnerPolicies(id);
      const policies = response.policies; 
      return policies
    }

   //function to create list of days
  // Generate 7 days from today
  const maxDays = 7 ; // Default to 7 if max_days is not set
  const dates = Array.from({ length: maxDays }, (_, index) => {
    return dayjs().add(index + 1, "day").format("DD-MM-YYYY");
  });

  const [customDate, setCustomDate] = useState(dates[0]);

  const handleChange = (event,newValue) => {
    if (newValue === dates.length) {
      setOpenModal(true); // Open modal if "Tanggal Lain" is clicked
      // setSelectedTab(-1);
    } else {
      setSelectedTab(newValue);
      setCustomDate(dates[newValue])
      setSelectedTime(null)
      setSelectedTableGroup(null)
      setSelectedTable(null)
    }
  };

  const handleDateSelect = () => {
    if (customDate) {
      setSelectedTab(dates.length); // Set to last index
      setOpenModal(false);
    }
  };
    

  useEffect(()=>{
    getAreasData().then(groupedAreas => {
      setAreas(groupedAreas);
      }
    );
    getAreaImageF(partnerID).then(images => {
      setAreaImage(images);
      }
    );
    getTableGroupList().then(tableGroups => {
      setTableGroups(tableGroups);
      getTableByGroupIDList(tableGroups).then(tablelist => {
        setTableListByGroupID(tablelist)
      });
      }
    );
    // console.log(customDate);
    
  },[selectedTime,customDate])
  
  
  
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString)
  const partnerID = urlParams.get('partnerID')
  
   useEffect(()=>{
      getPartnerPoliciesF(ls.get('sfPartner').id).then(data => {
        setPartnerPolicies(data)
      })
    },[])

  const style = {
    width: width,
    maxWidth: 480,
    margin: 0,
    bottom: 0,
    left: "auto",
    position: "fixed",
  };
  
  useEffect(()=> {
    userDetail
    ? navigate(`/reservation?partnerID=${ls.get("partnerID") ? ls.get("partnerID") : partnerID}`)
    : navigate(`/auth?partnerID=${ls.get("sfPartner") ? ls.get("sfPartner").id : partnerID}`, { state: { to: "/reservation", from:"/auth" } });
  }, userDetail);
  const timeNow = `${hours > 9 ? hours : "0" + hours}:${minutes > 9 ? minutes : "0" + minutes
  }:${seconds > 9 ? seconds : "0" + seconds}`;
  
  

  const updateDimensions = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    setWindowWidth(width);
    setWindowHeight(height);
  };

  useEffect(() => {
    const days = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ];
      const thisDay = days[new Date().getDay()];
      setPartnerDetails(ls.get("sfPartner"));

      if(!ls.get("partnerID")){
        ls.set("partnerID", partnerID)
      }

  
      if(!ls.get("sfOpenHour") || !ls.get("sfCloseHour") || !ls.get("sfLastOrder")){
        ls.set("sfOpenHour", ls.get("sfPartner").jam_buka)
        ls.set("sfCloseHour", ls.get("sfPartner").jam_tutup)
        ls.set("sfLastOrder", ls.get("sfHours")[`${thisDay}_last_order`])
      }

      updateDimensions();
  
      window.addEventListener("resize", updateDimensions);
  
      if (ls.get("sfOpenHour") && ls.get("sfOpenHour") < timeNow &&
        timeNow > ls.get("sfCloseHour")
        ) {
          setIsOpeningHour(false);
          setMsgToast(
            "Mohon maaf cafe sudah tutup, silakan coba kembali besok"
          );
          return
      }
  
  
      if(ls.get("sfOpenHour") && ls.get("sfOpenHour") > timeNow){
        setIsOpeningHour(false);
        setMsgToast("Mohon maaf cafe belum buka");
        return
      }
      
      if((ls.get("sfPartner").is_temporary_close==="1")){
        setIsOpeningHour(false)
        setMsgToast ("Mohon maaf cafe sedang tutup sementara")
        return
      }
      
      //cek max people reservation
      if (ls.get('sfPartner').max_people_reservation==="0") {
        setIsOpeningHour(false);
        setMsgToast(
          "Mohon maaf merchant belum menggunakan fitur reservasi"
        );
        return
      }

      // if (ls.get("sfShift") === "1") {
        if (ls.get("sfOpenHour") && ls.get("sfOpenHour") < timeNow && timeNow < ls.get("sfCloseHour")) {
          setIsOpeningHour(true);
        }
      // } 
      else {
        if (ls.get("sfOpenHour") && ls.get("sfOpenHour") < timeNow &&
        timeNow > ls.get("sfLastOrder") && timeNow < ls.get("sfCloseHour")
        ) {
          setIsOpeningHour(false);
          setMsgToast(
            "Mohon maaf waktu pemesanan anda melebihi waktu last order, silakan coba kembali besok"
          );
        return
        } else {
          if(!ls.get("sfShift")){
            setIsOpeningHour(true);
          }
          // else{
            // setMsgToast("Resto belum memulai shift. Mohon hubungi kasir");
          // }
          return
        }
    }
    return () => window.removeEventListener("resize", updateDimensions);
  }, [msgToast]);


  const actionsTextStyle = {
    width: "max-content",
    margin: 0,
  };

  const [open, setOpen] = React.useState(false);
  const [msg, setMsg] = React.useState("Cart kamu kosong");
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  // console.log(selectedTableGroup);
  
  //fungsi handle untuk pindah halaman
  const handleData = async (customTime, customDate, adult, child) => {

    const data = {
      customTime:customTime,
      customDate:customDate,
      adult:adult,
      child:child
    }
    ls.set('reservation_time',data)
    navigate('/select-table', {state:data})
  }

  const handleSubmit = async () => {
    setIsLoadingReservasi(true)
    const startTimeDate = dayjs(customDate,"DD-MM-YYYY").format("YYYY-MM-DD") + " " + selectedTime + ":00"
    const reservationData = {
      phone:customerPhone,
      name:customerName,
      email:customerEmail,
      description:description,
      reservation_time: startTimeDate,
      end_time:dayjs(startTimeDate).add(selectedTable.duration,selectedTable.duration_metric).format("YYYY-MM-DD HH:mm:ss"),
      frID:selectedTable.id,
      partner_id:ls.get('sfPartner').id,
      user_id:ls.get('redux_localstorage_simple').userData[0].id,
      pax:adult+child,
      booking_price: adult*selectedTable?.booking_price
    }


      const endTime = dayjs(reservationData.end_time, "YYYY-MM-DD HH:mm:ss"); 
      const closingTime = dayjs(`${endTime.format("YYYY-MM-DD")} ${ls.get('sfPartner').jam_tutup}`, "YYYY-MM-DD HH:mm:ss");
      console.log(endTime);
      console.log(closingTime);
      
      
      // Now you can safely compare
      if (endTime.isAfter(closingTime, "second")) {
        setStatus(0)
        setMsg("Durasi reservasi untuk meja ini melebihi jam tutup, silakan lakukan reservasi pada jam lain")
        setTimeout(() => {
            setIsOpen(true);
            // Hide after 3 seconds (adjust timing as needed)
            setTimeout(() => {
              setIsOpen(false);
            }, 3000);
          }, 300);
      } if (adult+child > selectedTable.capacity){
        setIsDialogOpen(true)
        // setStatus(0)
        // setMsg("Jumlah orang melebihi kapasitas meja, silahkan hubungi merchant")
        // setTimeout(() => {
        //     setIsOpen(true);
        //     // Hide after 3 seconds (adjust timing as needed)
        //     setTimeout(() => {
        //       setIsOpen(false);
        //     }, 3000);
        //   }, 300);
      } 
      else {
        console.log(selectedTable)
        await createAndPay(reservationData).then((response) => {
          if(response.success===1){
            const invoiceUrl = response.invoice_url
            setStatus(1)
            setMsg(invoiceUrl ?
              "Berhasil Membuat Reservasi, anda akan diarahkan ke halaman pembayaran"
              :
              "Berhasil Membuat Reservasi, silahkan bayar reservasi melalui link yang diberikan pada pesan whatsapp anda")
            setTimeout(() => {
                setIsOpen(true);
            
                // Hide after 3 seconds (adjust timing as needed)
                setTimeout(() => {
                  setIsOpen(false);
                  if(invoiceUrl){
                    // same tab, supaya redirectUrl dari payment gateway kembali ke halaman ini
                    window.location.href = invoiceUrl
                  }else if(response.iid){
                    navigate(`/history-detail?id=${response.iid}`)
                  }else{
                    navigate(`/?partnerID=${ls.get('sfPartner').id}`)
                  }
                }, 2000);
            
              }, 300);
          }else{
            setStatus(0)
            setMsg(response.msg)
            setTimeout(() => {
                setIsOpen(true);
            
                // Hide after 3 seconds (adjust timing as needed)
                setTimeout(() => {
                  setIsOpen(false);
                }, 3000);
            
              }, 300);
          }
        });
    }
      setIsLoadingReservasi(false)
  }

   // Initialize checked state for each policy
const [checkedItems, setCheckedItems] = useState(
  partnerPolicies.reduce((acc, item) => {
    acc[item.id] = false; // Ensure each item starts unchecked
    return acc;
  }, {})
);

useEffect(() => {
  if (partnerPolicies.length === 0) {
    setIsValid(true); // If no policies, set isValid to true
  } else {
    // Check if all checkboxes are checked
    const allChecked = partnerPolicies.every((item) => checkedItems[item.id]);
    setIsValid(allChecked);
  }
}, [checkedItems, partnerPolicies]);

// Handle checkbox change
const handleCheckboxChange = (id) => {
  setCheckedItems((prev) => ({
    ...prev,
    [id]: !prev[id],
  }));
};

const SelectionCard = ({ item, selected, onClick }) => (
  <Card
    sx={{
      width: 60,
      textAlign: "center",
      p: 1,
      cursor: "pointer",
      bgcolor: selected ? "primary.main" : "white",
      // color: selected ? "white" : "black",
      border: "1px solid #ccc",
      mx:0.5
    }}
    style={{color: selected ? "white" : "black"}}
    onClick={onClick}
  >
    <Typography variant="body1" fontWeight="bold">{item}</Typography>
  </Card>
);

  return (
    <DefaultContainer loading={loading} sx={{overflow:"auto"}}>
      <Toast isOpen={isOpen} message={msg} status={status} sx={{maxWidth:"480px"}} />
      {loading ? (
        <SkeletonOrder />
      ) : (
        <>
          <Grid
            container
            style={{
              position: "sticky",
              justifyContent: "center",
              maxWidth: 480,
              background: "#fff",
            }}
          >
            {!isOpeningHour && <Warning msg={msgToast} />}
            <Grid
              item
              xs={12}
              style={{
                padding: 15,
                fontWeight: 500,
                fontSize: 20,
                textAlign: "center",
                background: "#fff",
                wordWrap: "breakWord",
              }}
            >
              <DefaultHeader
                title={"Reservasi di "+partnerDetails.name}
                url={`/?partnerID=${ls.get("sfPartner").id}`}
              />
            </Grid>
            <Grid item xs={11}>
              <Slider {...settings}>
                {images.map((src, index) => (
                  <div key={index}>
                    <img
                      alt={`image-${index}`}
                      src={src.image==="" ? "/assets/img/logo/ur-biru.webp":src.image}
                      style={{
                        width: "100%",
                        height: "300px", // Set a fixed height (adjust as needed)
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "8px"
                      }}
                    />
                  </div>
                ))}
              </Slider>
            </Grid>
            {/* Adults Selection */}
            {ls.get('sfPartner').max_people_reservation!=="0" &&
              <Typography fontWeight="bold" fontSize={25} sx={{mt:2}}>Dewasa</Typography>}
            <Box sx={{ overflowX: "auto", whiteSpace: "nowrap", pb: 1, mx:3 }}>
              <Grid container sx={{ display: "flex", flexWrap: "nowrap" }}>
                {maxPerson.filter(num => num >= 1).map(num => (
                  <Grid item key={num}>
                    <SelectionCard
                      item={num}
                      selected={adult === num}
                      onClick={() => setAdult(num)}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
            {/* Children Selection */}
           { ls.get('sfPartner').max_people_reservation!=="0" &&
            <Typography fontWeight="bold" fontSize={25}>Anak-anak</Typography>}
            <Box sx={{ overflowX: "auto", whiteSpace: "nowrap", pb: 1, mx:3 }}>
              <Grid container sx={{ display: "flex", flexWrap: "nowrap" }}>
                {maxPerson.filter(num => num != ls.get('sfPartner').max_people_reservation).map(num => (
                  <Grid item key={num}>
                    <SelectionCard
                      item={num}
                      selected={child === num}
                      onClick={() => setChild(num)}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
            <Grid item xs={11}>
            <Paper elevation={3} sx={{ p: 2, borderRadius: 2 }}>
              <Tabs 
                value={selectedTab} 
                onChange={handleChange} 
                variant="scrollable" 
                scrollButtons="auto"
                sx={{ mb: 2 }}
              >
                {dates.map((date, index) => (
                  <Tab disabled={ls.get('sfPartner').max_people_reservation==="0"} key={index} label={date} />
                ))}
                <Tab disabled={ls.get('sfPartner').max_people_reservation==="0"} onClick={()=> setOpenModal(true)} label="Tanggal Lain" sx={{display:ls.get("sfPartner")?.max_days_reservation > 7 ? "block":"none"}} />
              </Tabs>
              <Box sx={{ p: 2, textAlign: "center", bgcolor: "#f5f5f5", borderRadius: 2 }}>
                <Typography variant="h6"> Pilih Waktu untuk Reservasi pada tanggal :  {customDate}</Typography>
                {/* GRID JAM */}
                <Grid container spacing={2} sx={{ mt: 1,  }}>
                  {timeSlots.map((time, index) => (
                    <Grid item xs={4} key={index}>
                      <Button 
                        disabled={ls.get('sfPartner').max_people_reservation==="0"}
                        variant={selectedTime === time ? "contained" : "outlined"}
                        sx={{
                          backgroundColor: selectedTime === time ? "primary.main" : "transparent",
                          color: selectedTime === time ? "white !important" : "primary.main", // Force text color
                          borderColor: "primary.main",
                        }}
                        fullWidth
                        onClick={() => { setSelectedTime(time); setSelectedTable(null); }}
                      >
                        {time}
                      </Button>
                    </Grid>
                  ))}
                </Grid>
              </Box>

              {/* Modal */}
              <Modal open={openModal} onClose={() => setOpenModal(false)}>
                <Box 
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    p: 4,
                    borderRadius: 2,
                    boxShadow: 24,
                    width: 300,
                    textAlign: "center",
                    bgcolor: "#FFFFFF",
                  }}
                >
                  <Typography variant="h6" mb={2}>Pilih Tanggal</Typography>
                  <TextField
                    type="date"
                    fullWidth
                    label={"Tanggal Reservasi"}
                    value={customDate ? dayjs(customDate, "DD-MM-YYYY").format("YYYY-MM-DD") : ""}
                    onChange={handleDateChange}
                    error={error}
                    helperText={error ? `Pilih tanggal antara ${minDate.format("DD-MM-YYYY")} dan ${maxDate.format("DD-MM-YYYY")}` : ""}
                    inputProps={{
                      min: minDate.format("YYYY-MM-DD"),
                      max: maxDate.format("YYYY-MM-DD"),
                    }}
                  />
                  <Button 
                    variant="contained" 
                    sx={{ mt: 2 }} 
                    onClick={handleDateSelect}
                    disabled={!customDate || error} // Disable if no date or error
                  >
                    Pilih
                  </Button>
                </Box>
              </Modal>

            </Paper>
            </Grid>
            {selectedTime && customDate &&
              <Button sx={{mt:2}} onClick={()=>handleData(selectedTime, customDate, adult, child)}>Lanjutkan</Button>
            }
            {/* {selectedTime && customDate &&
            <FormControl fullWidth sx={{mt:2}}>
                  <InputLabel id="demo-simple-select-label" sx={{m:1}}>Pilih Grup Meja</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    value={selectedTableGroup?.name ? "":selectedTableGroup?.name}
                    onChange={(e)=>{
                      setSelectedTableGroup({i:e.target.value, id:tableGroups[e.target.value]?.id ? tableGroups[e.target.value].id:"0", name:tableGroups[e.target.value]?.name ? tableGroups[e.target.value].name : "Semua"})
                    }}
                    sx={{mx:2,}}
                  >
                    <MenuItem value={tableGroups.length}>Semua</MenuItem>
                    {tableGroups.map((group,i)=> <MenuItem value={i}>{group.name}</MenuItem>)}
                  </Select>
            </FormControl>} */}
            {/* GRID MEJA */}
            {tableGroups && selectedTableGroup &&
            <Grid container spacing={2} sx={{ mt: 1, mr:2, ml:0.5 }}>
            {selectedTableGroup.i!==tableGroups.length ?
              tableListByGroupID[selectedTableGroup.i].map((table, index) => (
                <Grid item xs={4} key={index}>
                  <Button
                    disabled={table.reservationStatus==="1" ? true:false}
                    variant={selectedTable === table? "contained" : "outlined"} 
                    sx={{
                      backgroundColor: selectedTable === table ? "primary.main" : "transparent",
                      color: selectedTable === table ? "white !important" : "primary.main", // Force text color
                      borderColor: "primary.main",
                    }}
                    fullWidth
                    onClick={() => setSelectedTable(table)}
                  >
                    {table.idmeja}
                  </Button>
                </Grid>
              ))
              :
              areas.map((table, index) => (
                <Grid item xs={4} key={index}>
                  <Button
                    disabled={table.reservationStatus==="1" ? true:false}
                    variant={selectedTable === table? "contained" : "outlined"} 
                    sx={{
                      backgroundColor: selectedTable === table ? "primary.main" : "transparent",
                      color: selectedTable === table ? "white !important" : "primary.main", // Force text color
                      borderColor: "primary.main",
                    }}
                    fullWidth
                    onClick={() => setSelectedTable(table)}
                  >
                    {table.idmeja}
                  </Button>
                </Grid>
              ))
            }
            </Grid>}
            {selectedTable&&
              <Grid
              container
              spacing={2}
              sx={{
                mt: 1,
                mx: 3,
                textAlign: "center",
                alignItems: "center",
                justifyContent: "center", // Centers content horizontally
              }}
            >
              <Grid item xs={12}>
                <Typography fontWeight="bold" textAlign="center">{selectedTable?.name}</Typography>
              </Grid>
              {console.log(selectedTable)}
              <Grid item xs={12}>
                <img
                  alt=""
                  src={
                    selectedTable?.image!==""
                      ? selectedTable?.image
                      : "/assets/img/image-not-found.png"
                  }
                  style={{
                    width: selectedTable?.image!=="" ? "100%":"50%",
                    height: selectedTable?.image!=="" ? "100%":"50%",
                    objectFit: "cover",
                    objectPosition: "center",
                  }}
                />
              </Grid>
            
              <Grid item xs={12}sx={{mb:0}}>
                <Typography fontWeight="bold" textAlign="center" sx={{mb:0}}>
                  Maksimal {selectedTable?.capacity} Tamu
                </Typography>
              </Grid>
            
              <Grid item xs={12} sx={{mb:0,mt:0}}>
                <Typography fontWeight="bold" textAlign="center" sx={{mb:0,mt:0}}>
                  Durasi {selectedTable?.duration + " " + selectedTable.duration_metric}
                </Typography>
              </Grid>
            
              <Grid item xs={12} sx={{mb:0,mt:0}}>
                <Typography fontWeight="bold" textAlign="center"  sx={{mb:0,mt:0}}>
                  Minimum spend Rp <MoneyFormat value={selectedTable?.minimum_transaction}/>++
                </Typography>
              </Grid>
            
              <Grid item xs={12}>
                <Typography textAlign="center">{selectedTable?.description}</Typography>
              </Grid>
            </Grid>          
            }
            <Grid container spacing={2} sx={{ mt: 2, mr:2, ml:0.5 }}>
            <Button
              sx={{ display: (selectedTime == null || selectedTableGroup == null || selectedTable == null || adult===0) ? "none" : "block", 
                    alignItems:"center",
                    width:"100%"
              }}
              onClick={()=>setReservationModal(!reservationModal)}
            >
              Pilih Meja ini
            </Button>
            </Grid>
          </Grid>

          {/* MODAL KONFIRMASI */}
          <Modal open={reservationModal} onClose={handleClose}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 350,
                maxHeight: "80vh", // Limit height to 80% of viewport height
                bgcolor: "#FFFFFF",
                boxShadow: 24,
                p: 4,
                borderRadius: 2,
                overflow: "auto", // Enables scrolling if content overflows
                scrollbarWidth:"none"
              }}
            >
              
              <Box sx={{bgcolor:"white", mx:3}} display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h6" fontWeight="bold">
                  Detail Reservasi
                </Typography>
                <IconButton onClick={()=>setReservationModal(!reservationModal)}>
                  <CloseIcon />
                </IconButton>
              </Box>

              
              <Typography variant="h6" mt={2} mx={3} fontWeight="bold">
                {ls.get("sfPartner").name}
              </Typography>
              <Typography variant="body2" mx={3} color="text.secondary">
                {ls.get("sfPartner").address}
              </Typography>

              <Divider sx={{ my: 2 }} />

              
              <Typography fontWeight="bold" mx={3}>Ringkasan Reservasi</Typography>
              <Typography mx={3}>📅 {`${customDate} ${selectedTime} - ${dayjs(customDate + " " + selectedTime + ":00", "DD-MM-YYYY HH:mm:ss").add(+2, "hours").format("HH:mm")}`}</Typography>
              <Typography mx={3}>🍽️ {selectedTable?.name + ` (${selectedTable?.idmeja})`}</Typography>
              <Typography mx={3}>👤 {`${adult} Dewasa` + (child>0? ` + ${child} Anak`:``)}</Typography>
              <Divider sx={{ my: 2 }} />

              
              <Typography mx={3} fontWeight="bold">Detail Pemesan</Typography>
              <Typography mx={3}><TextField
                                      sx={{p:0, mt:1}}
                                      variant="outlined"
                                      label={"👤 Nama"}
                                      type="text"
                                      autoFocus
                                      defaultValue={ls.get('redux_localstorage_simple').userData[0]?.name}
                                      onChange={(e) => {
                                        setCustomerName(e.target.value);
                                      }}
                                      error={customerName && !/^[a-zA-Z\s]+$/.test(customerName)}
                                      helperText={customerName && !/^[a-zA-Z\s]+$/.test(customerName) ? "Only letters & spaces allowed" : ""}
                                    />
              </Typography> 
              <Typography mx={3}><TextField
                                      sx={{p:0, mt:1}}
                                      variant="outlined"
                                      label={"📞 No. Telpon"}
                                      type="tel"
                                      autoFocus
                                      defaultValue={ls.get('redux_localstorage_simple').userData[0]?.phone}
                                      onChange={(e) => {
                                        setCustomerPhone(e.target.value);
                                      }}
                                      error={customerPhone && !/^\d+$/.test(customerPhone)}
                                      helperText={customerPhone && !/^\d+$/.test(customerPhone) ? "Invalid phone number" : ""}
                                    />
              </Typography>
              <Typography mx={3}><TextField
                                      sx={{p:0, mt:1}}
                                      variant="outlined"
                                      label={"📧 Email"}
                                      type="email"
                                      autoFocus
                                      defaultValue={ls.get('redux_localstorage_simple').userData[0]?.email}
                                      onChange={(e) => {
                                        setCustomerEmail(e.target.value);
                                      }}
                                      error={customerEmail && !/^[\w.%+-]+@[\w.-]+\.[a-zA-Z]{2,}$/.test(customerEmail)}
                                      helperText={customerEmail && !/^[\w.%+-]+@[\w.-]+\.[a-zA-Z]{2,}$/.test(customerEmail) ? "Invalid email format" : ""}
                                    /> 
              </Typography>
              <Typography mx={3} color={"#979797"} fontSize={10}>*Notes : Jika ingin melakukan reservasi untuk orang lain, silakan ganti detail pemesan</Typography>
              <Divider sx={{ my: 2 }} />

              <Typography mx={3} fontWeight="bold">Catatan Tambahan</Typography>
              <TextField onChange={(e)=> setDescription(e.target.value)}placeholder="Masukkan catatan tambahan" sx={{width:"92%", ml:2 , mr:5}}/>
              
              <Divider sx={{ my: 2 }} />
              
               {partnerPolicies.length>0 &&
                <Typography mx={3} fontWeight="bold">Untuk melengkapi proses reservasi</Typography>
               }
                            {partnerPolicies.map((item) => (
                              <Typography mx={3} key={item.id}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={checkedItems[item.id] || false}
                                      onChange={() => handleCheckboxChange(item.id)}
                                    />
                                  }
                                  label={item.description}
                                />
                              </Typography>
                            ))}
                            {/* <Typography color={isValid ? "green" : "red"}>
                              {isValid ? "All policies are checked ✅" : "Please check all policies ❌"}
                            </Typography> */}
                            
              {partnerPolicies.length>0 && <Divider sx={{ my: 2 }} />}

              <Typography mx={3} fontWeight="bold">Detail Tagihan</Typography>
              <Typography mx={3}>Minimum Spend: <MoneyFormat value={selectedTable?.minimum_transaction}/></Typography>
              <Typography mx={3}>Booking Fee: 
                {bookingfee_customer_reservation==="1"?  <Typography><MoneyFormat value={selectedTable?.booking_price}/>/adult</Typography> :<MoneyFormat value={selectedTable?.booking_price}/>}
              </Typography>
              <Typography mx={3} fontWeight="bold" color="primary">
                Total: { bookingfee_customer_reservation==="1"? <MoneyFormat value={selectedTable?.booking_price*adult}/> : <MoneyFormat value={selectedTable?.booking_price}/>}
              </Typography>

              <Grid fullWidth sx={{display:"flex", alignItems:"center", justifyContent:"center", alignContent:"center"}}>
                {isLoadingReservasi ? 
                  <CircularProgress/>
                  :
                  <Button
                  disabled={!isValid}
                  variant="contained"
                  color="primary"
                  style={{ 
                    marginTop: 16, 
                    width: "50%", 
                    color: "white" // Warna teks
                  }}
                  // sx={{ mt: 2,width:"50%", color:"white"}}
                  onClick={()=>handleSubmit()}
                >
                  Buat Reservasi
                </Button>}
              </Grid>
              
            </Box>
          </Modal>
          {isDialogOpen &&
            <Dialog
              open={isDialogOpen} onClose={() => setIsDialogOpen(false)}>
                  <DialogTitle>Informasi</DialogTitle>
                  <DialogContent sx={{maxWidth:"320px"}}>
                      <Typography>Jumlah orang melebihi kapasitas meja, silakan hubungi merchant</Typography>
                  </DialogContent>
                  <DialogActions>
                      <Button sx={{color:"#7f7f7f"}} onClick={() => setIsDialogOpen(false)} color="primary">
                          Tutup
                      </Button>
                      <Button onClick={() => { 
                        // 1. Menghilangkan karakter selain angka
                          let formatted = partnerDetails.phone.replace(/\D/g, "");

                        // 2. Menghilangkan angka 0 di depan (prefix)
                        //    Kemudian diganti dengan 62
                          if (formatted.startsWith("0")) {
                            formatted = "62" + formatted.substr(1);
                          }
                          window.open("http://wa.me/" + formatted, "_blank");
                        }} color="primary">
                          Hubungi merchant
                      </Button>
                  </DialogActions>
              </Dialog>
            }
          <Grid
            style={{ paddingTop: isOpeningHour ? 108 : 156.02 }}
          >
          </Grid>
          <div
            style={style}
          >
            <Backdrop open={open} />
          </div>
        </>
      )}
    </DefaultContainer>
  );
};
const mapStateToProps = (state) => {
  return {
    currency: state.currencyData,
    // cartData: state.cartData,
    cartData: state.cartData.filter(
      (data) => data.partnerID === ls.get("partnerID")
    ),
    userDetail: state.userData[state.userData.length - 1],
    wishlistData: state.wishlistData,
    compareData: state.compareData,
  };
};

export default connect(mapStateToProps, null)(ReservationScreen);
